import React, { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { Navigate, useParams, useNavigate } from "react-router-dom";
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import { BreadcrumbContext } from '../../../../components/Breadcrumb';
import Loader from "../../../../components/Loader";
import { Card, CardContent, Stack, Alert, Typography, Button } from "@mui/material";


const Invite = () => {
    const { t } = useTranslation();
    const { code } = useParams();

    const navigate = useNavigate();
    const mountedRef = useRef(true);

    const [invite, setInvite] = useState(null);
    const [error, setError] = useState(null);
    const [inSubmit, setInSubmit] = useState(false);
    const [success, setSuccess] = useState(false);
    const { setBreadcrumb } = useContext(BreadcrumbContext);

    useEffect(() => {
        setBreadcrumb([
            {
                to: "/",
                text: t('common.home'),
                active: false
            },
            {
                to: null,
                text: t('invite.title'),
                active: true
            }
        ]);
        if(code){
            let isSubscribed = true;
            setError(null);
            const getInvite = CloudFunctions.httpsCallable('getInvite');
            getInvite({
                inviteId: code
            }).then(res => {
                if (!mountedRef.current) return null
                if(isSubscribed){
                    setInvite(res.data);
                }
            }).catch(err => {
                if (!mountedRef.current) return null
                if(isSubscribed){
                    setError(err.message);
                }
            });
            return () => (isSubscribed = false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code, setBreadcrumb, t]);

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    },[]);

    return (
        <>
            {success?(
                <Navigate to={"/account/"+invite.accountId+"/"} replace />
            ):(
                <Card
                    sx={{
                        backgroundColor: (theme) => theme.custom.card,
                        boxShadow: (theme) => theme.custom.cardShadow,
                        border: (theme) => `1px solid ${theme.custom.border}`,
                    }}
                >
                    <CardContent>
                        <Stack spacing={3}>
                            {error !== null &&
                                <Alert severity="error">{error}</Alert>
                            }
                            {invite === null?(
                                <Loader text={t('invite.loadingInvite')}></Loader>
                            ):(
                                <>
                                    <Typography>
                                        {t('invite.promptPrefix')} <strong>{invite.accountName}</strong>. {t('invite.promptSuffix')}
                                    </Typography>
                                    <Stack direction="row" spacing={1} mt={2}>
                                        <Button disabled={inSubmit} variant="contained" onClick={e => {
                                            e.preventDefault();
                                            setInSubmit(true);
                                            const acceptInvite = CloudFunctions.httpsCallable('acceptInvite');
                                            acceptInvite({
                                                inviteId: code
                                            }).then(res => {
                                                if (!mountedRef.current) return null
                                                setSuccess(true);
                                            }).catch(err => {
                                                if (!mountedRef.current) return null
                                                setError(err.message);
                                            });
                                        }}>{inSubmit && <Loader />}
                                        {t('invite.accept')}
                                        </Button>
                                        <Button color="secondary" variant="contained" disabled={inSubmit} onClick={() => navigate('/')}>{t('invite.ignore')}</Button>
                                    </Stack>
                                </>
                            )}
                        </Stack>
                    </CardContent>
                </Card>
            )}
        </>
    )
}

export default Invite;
